import * as React from 'react';
import { observer } from 'mobx-react';
import { BaseFieldState } from './base-field-state';
import { ModelMetadata } from '../../../LoggedInWeb/loggedinweb-generated';
import { IFormFieldProps, FormField } from './form-field';
import { SelectOptionValue, ISelectCommonProps, Select, SelectOption } from '../primitives/select';
import { classNames } from '../../utils/classnames';

export type SelectOption = SelectOption;

export class SelectFieldState extends BaseFieldState<SelectOptionValue> {
	constructor(initialValue: SelectOptionValue, metadata?: ModelMetadata.IPropertyMetadata) {
		super(initialValue, metadata);
	}
}

export type ISelectFieldProps = ISelectCommonProps & IFormFieldProps & { fieldState: SelectFieldState };

@observer
export class SelectField extends React.Component<ISelectFieldProps> {
	render() {
		const { label, className, tooltip, fieldState, additionalClassNames, ...rest } = this.props;
		const { error, onChange, value, hasError } = fieldState;
		const classes = classNames(additionalClassNames, hasError ? `input-validation-error` : null);

		return (
			<FormField label={label} className={className} tooltip={tooltip} error={error}>
				<Select
					{...rest}
					onChange={onChange}
					value={value}
					ariaInvalid={hasError}
					additionalClassNames={classes}
				/>
			</FormField>
		);
	}
}
